import state from '../common/state.store';
import getters from '../common/getters.store';
import mutations from '../common/mutations.store';
import actions from './actions.store';

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
};
